module.exports = __webpack_public_path__ + "af78c42cd92df62d019f693ce95a9ea8.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Light-Oblique.ttf
// module id = 397
// module chunks = 0